import React from 'react';
import { Link } from 'react-router-dom';
import { InfoIcon, PlayIcon } from 'lucide-react';
import { Logo } from './Logo';
import { DemoBadge } from './DemoBadge';
import { PosterFallback } from './PosterFallback';
import { getMetaParts } from '../utils/production';
import { buttonClass, pagePadding } from '../utils/styles';
import type { Production } from '../types/production';
interface HeroProps {
  production: Production;
}
export function Hero({
  production
}: HeroProps) {
  const meta = getMetaParts(production);
  const detailPath = `/titulo/${production.slug}`;
  return <section aria-labelledby="hero-title" className="relative isolate flex h-[86svh] min-h-[560px] max-h-[980px] w-full items-end overflow-hidden bg-night" data-id="element-186" data-mp="sb1efy4p8fa9">
      <div className="absolute inset-0 -z-10" data-id="element-187" data-mp="neklmqmk1cqu">
        {production.posterUrl ? <img src={production.posterUrl} alt="" loading="eager" decoding="async" className="h-full w-full object-cover" data-id="element-188" data-mp="3czfl7z4xc761" /> : <PosterFallback variant="hero" data-id="element-189" data-mp="3j6g1bysfzti2" />}
        <div className="absolute inset-0 bg-gradient-to-r from-night via-night/70 to-night/0" data-id="element-190" data-mp="3o6kg9kdpcg66" />
        <div className="absolute inset-0 bg-gradient-to-t from-night via-night/20 to-night/0" data-id="element-191" data-mp="39b4l1c1dye87" />
      </div>

      <div className={`w-full pb-20 md:pb-28 ${pagePadding}`} data-id="element-192" data-mp="3e8ehvcr3ts62">
        <div className="max-w-2xl" data-id="element-193" data-mp="30ib0p0730onh">
          <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-mist md:text-xs" data-id="element-194" data-mp="30h9blrt8e1mr">
            <Logo variant="mark" className="h-6 w-6 text-[13px]" data-id="element-195" data-mp="35a2hij0frg0f" />
            Estreno destacado
            {production.isDemo && <DemoBadge data-id="element-196" data-mp="2qi0lja1hl75o" />}
          </p>

          <h1 id="hero-title" className="mt-5 font-display text-[2.75rem] font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl xl:text-8xl" data-id="element-197" data-mp="2vi50gvmqxtts">
            {production.title}
          </h1>

          {meta.length > 0 && <p className="mt-5 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm font-medium text-white/90" data-id="element-198" data-mp="s2jj7lrcvge8">
              {meta.map((part, i) => <React.Fragment key={part} data-id="element-199" data-mp="n98cdkmjmzmb" data-mpi={i}>
                  {i > 0 && <span aria-hidden="true" className="h-1 w-1 rounded-full bg-mist" data-id="element-200" data-mp="ibgjana5x7gj" />}
                  <span data-id="element-201" data-mp="ddnfg0wc0pjf">{part}</span>
                </React.Fragment>)}
            </p>}

          {production.synopsis && <p className="mt-4 line-clamp-3 max-w-xl text-base leading-relaxed text-mist md:text-lg" data-id="element-202" data-mp="1b049mx9rqn0y">
              {production.synopsis}
            </p>}

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-203" data-mp="111oln361ftvo">
            <Link to={`${detailPath}?play=1`} className={buttonClass('primary', 'lg')} data-id="element-204" data-mp="x14ohzlgsq9j">
              <PlayIcon className="h-5 w-5 fill-current" data-id="element-205" data-mp="x3h2y2s0kihu" />
              Ver ahora
            </Link>
            <Link to={detailPath} className={buttonClass('secondary', 'lg')} data-id="element-206" data-mp="3lqm2jypo95ux">
              <InfoIcon className="h-5 w-5" data-id="element-207" data-mp="3hq23uqpg9u6o" />
              Más información
            </Link>
          </div>
        </div>
      </div>
    </section>;
}